import { PATTERNS } from '../../constants/validations';

export default function(value) {
  return PATTERNS.AMOUNT.test(value);
}



// WEBPACK FOOTER //
// ./src/utils/validations/amountValidator.js